<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    :id="'transactions-'+order.order_id"
    body-class="cp-sidebar__body"
    sidebar-class="cp-sidebar"
    @change="toggleScrollbar()"
  >

    <SidebarHeader :title="'Your Transactions'" @clear="toggleScrollbar" />
    <div class="cp-sidebar__main">
      <ProcessingLoader v-if="processing" />
      <template v-else-if="hasTransactions">
        <div class="cp-sidebar__trans" v-for="(transaction, transactionDate) in transactions" v-bind:key="'transaction-'+transactionDate">
          <div class="cp-sidebar__trans__date">{{transactionDate}}</div>
          <div class="cp-sidebar__trans__info" v-for="(transactionInfo, transId) in transaction" v-bind:key="'transaction-info-'+transId">
            <div class="cp-sidebar__trans__info__top">
              <span>#{{transId}}</span>
              <span class="badge cp-badge active">{{transactionInfo.status}}</span>
            </div>
            <div class="cp-sidebar__trans__info__item" v-for="item in transactionInfo['items']" v-bind:key="'transaction-item-'+item.id">
              <div class="cp-sidebar__trans__info__item__image">
                <img :src="getItemImageUrl(item)" @error="setAltImg($event,item)" alt="" />
              </div>
              <div class="cp-sidebar__trans__info__item__info">
                <span class="text-ellipses">{{item.name}}</span>
                <span>Quantity: {{item.quantity}}</span>
              </div>
              <div class="cp-sidebar__trans__info__item__price">
                <span>{{item.total_price | currency(order.currency)}}</span>
              </div>
            </div>
          </div>
          <hr />
          <div class="cp-sidebar__trans__total__info">
            <div>
              <span>Subtotal:</span>
              <span class="cp-sidebar__trans__total__info__price">{{ order.subtotal | currency(order.currency) }}</span>
            </div>
            <div>
              <span>Shipping Fee: <span v-if="order.shipping_price == 0">(Free Shipping)</span></span>
              <span class="cp-sidebar__trans__total__info__price">{{ order.shipping_price | currency(order.currency) }}</span>
            </div>
            <div v-if="order.tax > 0">
              <span>Taxes:</span>
              <span class="cp-sidebar__trans__total__info__price">{{ order.tax | currency(order.currency) }}</span>
            </div>
            <div v-if="order.refund > 0">
              <span>Refunded:</span>
              <span class="cp-sidebar__trans__total__info__price refund">-{{ order.refund | currency(order.currency) }}</span>
            </div>
          </div>
          <hr />
          <div class="cp-sidebar__trans__total__info">
            <div>
              <span>Total Amount: <span class="cp-badge badge active">Paid</span></span>
              <span class="cp-sidebar__trans__total__info__price total">{{ order.total_remaining_balance | currency(order.currency) }}</span>
            </div>
          </div>
          <b-button class="cp-sidebar__btn no-outline-btn mt-0 d-md-none" variant="primary" @click.stop="toggleScrollbar()">
            Done
          </b-button>
        </div>
      </template>
      <template v-else>
        <div class="centered-block">
          <div class="step-title">No transactions found</div>
        </div>
      </template>
    </div>
  </b-sidebar>
</template>

<script>
import { TranResponseStrings } from '@/constants'
import {
  formatCurrency,
  toggleBodyScrollbar,
  getHumanReadableDate,
  getItemImageUrl,
  setFallbackImageUrl
} from '@/utils'
import axios from 'axios'
import ProcessingLoader from '@/components/ProcessingLoader'
import SidebarHeader from '@/components/Sidebar/SidebarHeader'

export default {
  name: 'OrderTransactions',
  components: {SidebarHeader, ProcessingLoader},
  props: {
    order: Object
  },
  data: function() {
    return {
      show: false,
      processing: true,
      transactions: {}
    }
  },
  computed: {
    hasTransactions: function() {
      return this.order && this.order.items.some(item => item.transactions && item.transactions.length > 0)
    }
  },
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar()
      this.$emit('clear')
    },
    close: function() {
      this.$bvModal.hide('order-transactions')
      this.$emit('close')
    },
    populateTransactions: function() {
      let transactions = {}

      for (let item of this.order.items) {
        (item.transactions || []).forEach((transaction) => {
          const transDate = getHumanReadableDate(transaction.created, true)
          if (!transactions[transDate]) {
            transactions[transDate] = {}
          }

          transactions[transDate][transaction.id.toString()] = {
            refund_amount: transaction.refund_amount,
            status: TranResponseStrings[transaction.response_type],
            amount: formatCurrency(transaction.amount, this.order.currency),
            refund: formatCurrency(transaction.refund_amount, this.order.currency),
            hasRefundAmount: transaction.refund_amount > 0,
            items: this.order.items
          }
        })
      }

      this.transactions = transactions
      this.processing = false
    },
    getItemImageUrl: function(item) {
      return getItemImageUrl(item, 'medium')
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item, 'medium', true)
    }
  },
  created() {
    toggleBodyScrollbar(true)
    if (this.order) {
      if (Object.values(this.transactions).length === 0) {
        if (!this.hasTransactions) {
          let requests = []
          if (this.order && this.order.items.length) {
            requests = requests.concat(this.order.items.map((item) => axios.get(`/order_items/${item.id}/`)))
          }

          if (requests.length) {
            this.processing = true
            Promise.all(requests).then(response => {
              this.order['items'] = response.map((result) => result.data)
              this.populateTransactions()
            }, () => {
              this.processing = false
            })
          } else {
            this.processing = false // not allowed to show transactions, so nothing to do
          }
        } else {
          this.populateTransactions(this.order['items'])
        }
        return
      }
    }
    this.processing = false
  }
}
</script>

<style scoped>

</style>
